export interface DictionaryFuelFeeAddRequest {
    name: string;
    sapName: string;
}